import fetchAPI from '../utils/service';

function getPagesRequest() {
  return {
    type: 'GET_PAGES_REQUEST',
  };
}
function getPagesSuccess(payload) {
  return {
    type: 'GET_PAGES_SUCCESS',
    payload,
  };
}
function getPagesFailure() {
  return {
    type: 'GET_PAGES_FAILURE',
  };
}

function getPages() {
  return async (dispatch) => {
    await dispatch(getPagesRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/page/list',
      });
      if (res.status === 200) {
        await dispatch(getPagesSuccess(res.data));
      } else {
        await dispatch(getPagesFailure());
      }
    } catch (error) {
      await dispatch(getPagesFailure());
    }
  };
}

function getDetailPageRequest() {
  return {
    type: 'GET_DETAIL_PAGE_REQUEST',
  };
}
function getDetailPageSuccess(payload) {
  return {
    type: 'GET_DETAIL_PAGE_SUCCESS',
    payload,
  };
}
function getDetailPageFailure() {
  return {
    type: 'GET_DETAIL_PAGE_FAILURE',
  };
}

function getDetailPage(id) {
  return async (dispatch) => {
    await dispatch(getDetailPageRequest());
    try {
      const res = await fetchAPI({
        endpoints: `/page/detail/${id}`,
      });
      if (res.status === 200) {
        await dispatch(getDetailPageSuccess(res.data));
      } else {
        await dispatch(getDetailPageFailure());
      }
    } catch (error) {
      await dispatch(getDetailPageFailure());
    }
  };
}

function createPageRequest() {
  return {
    type: 'CREATE_PAGE_REQUEST',
  };
}
function createPageSuccess(data) {
  return {
    type: 'CREATE_PAGE_SUCCESS',
    payload: {
      data,
    },
  };
}
function createPageFailure() {
  return {
    type: 'CREATE_PAGE_FAILURE',
  };
}

function createPage({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(createPageRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/page',
      });
      if (res.status === 201) {
        await dispatch(createPageSuccess(res.data));
        await response.success();
      } else {
        await dispatch(createPageFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(createPageFailure());
      await response.failure();
    }
  };
}

function editPageRequest() {
  return {
    type: 'EDIT_PAGE_REQUEST',
  };
}
function editPageSuccess(data, _id) {
  return {
    type: 'EDIT_PAGE_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editPageFailure() {
  return {
    type: 'EDIT_PAGE_FAILURE',
  };
}

function editPage({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(editPageRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/page/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(editPageSuccess(res.data, _id));
        await response.success();
      } else {
        await dispatch(editPageFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(editPageFailure());
      await response.failure();
    }
  };
}

function deletePageRequest() {
  return {
    type: 'DELETE_PAGE_REQUEST',
  };
}
function deletePageSuccess(_id) {
  return {
    type: 'DELETE_PAGE_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deletePageFailure() {
  return {
    type: 'DELETE_PAGE_FAILURE',
  };
}

function deletePage({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    await dispatch(deletePageRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/page/${_id}`,
      });
      if (res.status === 200) {
        await dispatch(deletePageSuccess(_id));
        await response.success();
      } else {
        await dispatch(deletePageFailure());
        await response.failure();
      }
    } catch (error) {
      await dispatch(deletePageFailure());
      await response.failure();
    }
  };
}

function logoutPage() {
  return {
    type: 'LOGOUT',
  };
}

export {
  getPages,
  getDetailPage,
  createPage,
  editPage,
  deletePage,
  logoutPage,
};



// WEBPACK FOOTER //
// ./src/actions/page.js